export const SKILLS_REQUIRED_MESSAGE = "Select at least one deployed skill to continue.";
